import React from 'react';
import LoginLogo from '../../images/LoginLogo.png';

export default function VideoLogo() {
  return <img src={LoginLogo} alt="Logo" height={96} width={96} />;
}
